import { render, staticRenderFns } from "./MasterJournalPopup.vue?vue&type=template&id=bdd648d0"
import script from "./MasterJournalPopup.vue?vue&type=script&lang=js"
export * from "./MasterJournalPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports